import Api from './api'

// ── Payment Methods ──

export const getPaymentMethods = async () => {
  try {
    const result = await Api.get(`/saas-proxy/billing/payment-methods`)
    return result
  } catch (err) {
    console.error('getPaymentMethods error:', err)
    return { data: { success: false, data: [], errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao carregar meios de pagamento'] } }
  }
}

export const createSetupIntent = async () => {
  try {
    const result = await Api.post(`/saas-proxy/billing/payment-methods/setup-intent`)
    return result
  } catch (err) {
    console.error('createSetupIntent error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao criar setup intent'] } }
  }
}

export const setDefaultPaymentMethod = async (hirerId, paymentMethodId) => {
  try {
    const result = await Api.post(`/saas-proxy/billing/payment-methods/set-default`, { paymentMethodId })
    return result
  } catch (err) {
    console.error('setDefaultPaymentMethod error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao definir padrao'] } }
  }
}

export const deletePaymentMethod = async (hirerId, paymentMethodId) => {
  try {
    const result = await Api.delete(`/saas-proxy/billing/payment-methods/${paymentMethodId}`)
    return result
  } catch (err) {
    console.error('deletePaymentMethod error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao remover cartao'] } }
  }
}

// ── Invoices ──

export const getInvoices = async (hirerId, limit = 20, offset = 0) => {
  try {
    const result = await Api.get(`/saas-proxy/billing/invoices?limit=${limit}&offset=${offset}`)
    return result
  } catch (err) {
    console.error('getInvoices error:', err)
    return { data: { success: false, data: [], errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao carregar faturas'] } }
  }
}

export const getInvoiceDetail = async (hirerId, invoiceId) => {
  try {
    const result = await Api.get(`/saas-proxy/billing/invoices/${invoiceId}`)
    return result
  } catch (err) {
    console.error('getInvoiceDetail error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao carregar detalhe da fatura'] } }
  }
}

export const retryInvoicePayment = async (invoiceId) => {
  try {
    const result = await Api.post(`/saas-proxy/billing/invoices/${invoiceId}/retry`)
    return result
  } catch (err) {
    console.error('retryInvoicePayment error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao retentar pagamento'] } }
  }
}

export const getUpcomingInvoice = async () => {
  try {
    const result = await Api.get(`/saas-proxy/billing/invoices/upcoming`)
    return result
  } catch (err) {
    console.error('getUpcomingInvoice error:', err)
    return { data: { success: false, errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao carregar proxima fatura'] } }
  }
}

// ── History ──

export const getBillingHistory = async (hirerId, limit = 50, offset = 0) => {
  try {
    const result = await Api.get(`/saas-proxy/billing/history?limit=${limit}&offset=${offset}`)
    return result
  } catch (err) {
    console.error('getBillingHistory error:', err)
    return { data: { success: false, data: [], errors: [err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : 'Erro ao carregar historico'] } }
  }
}
